import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button, Tab, Tabs, TextField, Box, Typography, Grid, IconButton, DialogActions } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import moment from "moment";
import TableComponent from "components/grid";
import CustomPagination from "components/CustomPagination";
import { RxCross2 } from "react-icons/rx";
import { useGetServiceDetailsQuery, useLazyGetServiceDetailsQuery } from "store/slices/apis/procurementDashboardSlice";



const ProcurementServiceListPopUp = (props) => {
    const {header, open, handleClose, data, } = props;
    const { projectId } = useParams();
    const [loading, setLoading] = useState(false);
    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('createdDate');
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const dispatch = useDispatch();
    const [subTabValue, setSubTabValue] = useState(0)

    const subTabs = [
        { label: "Sitc", value: 0 },
        { label: "Hotel-Sitc", value: 1 },

    ];


    const [trigger, { data: procurementList, isLoading }] = useLazyGetServiceDetailsQuery()


    const [filters, setFilters] = useState({
        ...data,
        ProjectId: projectId,
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,

    });

    useEffect(() => {
        trigger(filters);
    }, []);

    const getData = (value) => {
        if (value === 0) {
            return procurementList?.data?.sitcItems || [];
        }
        if (value === 1) {
            return procurementList?.data?.hotelSitcItems || [];
        }
        return [];
    };

    const getCount = (value) => {
        if (value === 0) {
            return procurementList?.data?.sitcCount || 0;
        }
        if (value === 1) {
            return procurementList?.data?.hotelSitcCount || 0;
        }
        return 0;

    }


    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';


        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'
        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters);
    };

    const handlePageChange = (newPage) => {
         setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
         const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const handleSubTabChange = (event, newValue) => {
        setSubTabValue(newValue);
    };

    const getColumns = () => {
        if (subTabValue === 0) {
            return [
                // {
                //     name: "",
                //     field: "actions",
                //     width: "10px",
                //     sticky: true,
                //     renderer: (row) => (
                //         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                //             <IconButton
                //                 size="small"
                //                 onClick={(e) => handleMenuOpen(e, row)}
                //             >
                //                 <MoreVertIcon fontSize="small" />
                //             </IconButton>
                //         </Box>
                //     ),
                // },
                {
                    name: "ID",
                    field: "customId",
                    width: "100px",
                    sticky: true
                },
                {
                    name: "Budgeted Cost (In INR)",
                    field: "budgetedCost",
                    sticky: true,
                    renderer: (row) => (
                        <>
                            {row?.budgetedCost !== null && row?.budgetedCost !== undefined
                                ? Number(row.budgetedCost).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                                : '-'}
                        </>
                    ),
                },
                {
                    name: "Actual Cost (In INR)",
                    field: "actualCost",
                    sticky: true,
                    renderer: (row) => (
                        <>
                            {row?.actualCost !== null && row?.actualCost !== undefined
                                ? Number(row.actualCost).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                                : '-'}
                        </>
                    ),
                },
                {
                    name: "Legal Entity",
                    field: "legalEntity",
                    renderer: (row) => (
                        <>
                            {row?.legalEntity ? row?.legalEntity : '-'}
                        </>
                    ),
                },
                {
                    name: "Source Department",
                    field: "sourceDepartment",
                    renderer: (row) => (
                        <>
                            {row?.sourceDepartment ? row?.sourceDepartment : '-'}
                        </>
                    ),
                },
                {
                    name: "Procurement Owner",
                    field: "procurementOwner",
                    renderer: (row) => (
                        <>
                            {row?.procurementOwner ? row?.procurementOwner : '-'}
                        </>
                    ),
                },
                {
                    name: "Planned Date For Service Request",
                    field: "plannedDateForServiceRequest",
                    renderer: (row) => (
                        <>
                            {row?.plannedDateForServiceRequest ? moment(row.plannedDateForServiceRequest).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Tender Package Release Date",
                    field: "tenderPackageReleaseDate",
                    renderer: (row) => (
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {row?.tenderPackageReleaseDate ? moment(row.tenderPackageReleaseDate).format("DD MMM YYYY") : '-'}
                        </Box>
                    ),
                },
                {
                    name: "LOI Reference",
                    field: "loiReference",
                    renderer: (row) => (
                        <>
                            {row?.loiReference ? row?.loiReference : '-'}
                        </>
                    ),
                },
                {
                    name: "Vendor Name",
                    field: "vendorName",
                    renderer: (row) => (
                        <>
                            {row?.vendorName ? row?.vendorName : '-'}
                        </>
                    ),
                },
                {
                    name: "Actual LOI Date",
                    field: "actualLoiWoDate",
                    renderer: (row) => (
                        <>
                            {row?.actualLoiWoDate ? moment(row.actualLoiWoDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Actual Service Request/Indent Date",
                    field: "actualServiceRequestIndentDate",
                    renderer: (row) => (
                        <>
                            {row?.actualServiceRequestIndentDate ? moment(row.actualServiceRequestIndentDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Planned Date RFP/RFQ Floating",
                    field: "plannedRfpRfqFloatingDate",
                    renderer: (row) => (
                        <>
                            {row?.plannedRfpRfqFloatingDate ? moment(row.plannedRfpRfqFloatingDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                // {
                //     name: "Cutoff Date For Receipt Of Bids",
                //     field: "bidReceiptCutoffDate",
                //     renderer: (row) => (
                //         <>
                //             {row?.bidReceiptCutoffDate ? moment(row.bidReceiptCutoffDate).format("DD MMM YYYY") : '-'}
                //         </>
                //     ),
                // },
                {
                    name: "Planned Date Of Release Of LOI/WO/PO",
                    field: "plannedLoiReleaseDate",
                    renderer: (row) => (
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {row?.plannedLoiReleaseDate ? moment(row.plannedLoiReleaseDate).format("DD MMM YYYY") : '-'}
                        </Box>
                    ),
                },
                {
                    name: "Planned Finish Of The Activity At Site",
                    field: "plannedFinishAtSiteDate",
                    renderer: (row) => (
                        <>
                            {row?.plannedFinishAtSiteDate ? moment(row.plannedFinishAtSiteDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Planned Start Of The Activity At Site",
                    field: "plannedStartAtSiteDate",
                    renderer: (row) => (
                        <>
                            {row?.plannedStartAtSiteDate ? moment(row.plannedStartAtSiteDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                // {
                //     name: "Lead Time (Days)",
                //     field: "leadTimeDays",
                //     renderer: (row) => (
                //         <>
                //             {row?.leadTimeDays ? row?.leadTimeDays : '-'}
                //         </>
                //     ),
                // },
                {
                    name: "Mobilization Required Days Left",
                    field: "mobilizationRequiredDaysLeft",
                    renderer: (row) => (
                        <>
                            {row?.mobilizationRequiredDaysLeft ? row?.mobilizationRequiredDaysLeft : '-'}
                        </>
                    ),
                },
                {
                    name: "Last Updated Date",
                    field: "lastUpdatedDate",
                    renderer: (row) => (
                        <>
                            {row?.lastUpdatedDate ? moment(row.lastUpdatedDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Status",
                    field: "status",
                    renderer: (row) => (
                        <>
                            {row?.status ? row?.status : '-'}
                        </>
                    ),
                },
                {
                    name: "Remarks / Notes",
                    field: "remark",
                    width: "300px",
                    renderer: (row) => (
                        <>
                            {row?.remark ? row?.remark : '-'}
                        </>
                    ),
                },
            ];
        } else {
            return [
                // {
                //     name: "",
                //     field: "actions",
                //     width: "10px",
                //     sticky: true,
                //     renderer: (row) => (
                //         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                //             <IconButton
                //                 size="small"
                //                 onClick={(e) => handleMenuOpen(e, row)}
                //             >
                //                 <MoreVertIcon fontSize="small" />
                //             </IconButton>
                //         </Box>
                //     ),
                // },
                {
                    name: "ID",
                    field: "customId",
                    width: "100px",
                    sticky: true
                },
                {
                    name: "Budgeted Cost (In INR)",
                    field: "budgetedCost",
                    sticky: true,
                    renderer: (row) => (
                        <>
                            {row?.budgetedCost !== null && row?.budgetedCost !== undefined
                                ? Number(row.budgetedCost).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                                : '-'}
                        </>
                    ),
                },
                {
                    name: "Actual Cost (In INR)",
                    field: "actualCost",
                    sticky: true,
                    renderer: (row) => (
                        <>
                            {row?.actualCost !== null && row?.actualCost !== undefined
                                ? Number(row.actualCost).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                                : '-'}
                        </>
                    ),
                },
                // {
                //     name: "Source Department",
                //     field: "sourceDepartment",
                //     renderer: (row) => (
                //         <>
                //             {row?.sourceDepartment ? row?.sourceDepartment : '-'}
                //         </>
                //     ),
                // },
                // {
                //     name: "Procurement Owner",
                //     field: "procurementOwner",
                //     renderer: (row) => (
                //         <>
                //             {row?.procurementOwner ? row?.procurementOwner : '-'}
                //         </>
                //     ),
                // },
                // {
                //     name: "Planned Date For Service Request",
                //     field: "plannedDateForServiceRequest",
                //     renderer: (row) => (
                //         <>
                //             {row?.plannedDateForServiceRequest ? moment(row.plannedDateForServiceRequest).format("DD MMM YYYY") : '-'}
                //         </>
                //     ),
                // },
                // {
                //     name: "Actual Service Request/Indent Date",
                //     field: "actualServiceRequestIndentDate",
                //     renderer: (row) => (
                //         <>
                //             {row?.actualServiceRequestIndentDate ? moment(row.actualServiceRequestIndentDate).format("DD MMM YYYY") : '-'}
                //         </>
                //     ),
                // },
                {
                    name: "LOI Reference",
                    field: "loiReference",
                    renderer: (row) => (
                        <>
                            {row?.loiReference ? row?.loiReference : '-'}
                        </>
                    ),
                },
                {
                    name: "Vendor Name",
                    field: "vendorName",
                    renderer: (row) => (
                        <>
                            {row?.vendorName ? row?.vendorName : '-'}
                        </>
                    ),
                },
                {
                    name: "Actual LOI/WO Date",
                    field: "actualLoiWoDate",
                    renderer: (row) => (
                        <>
                            {row?.actualLoiWoDate ? moment(row.actualLoiWoDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                // {
                //     name: "Planned Date RFP/RFQ Floating",
                //     field: "plannedRfpRfqFloatingDate",
                //     renderer: (row) => (
                //         <>
                //             {row?.plannedRfpRfqFloatingDate ? moment(row.plannedRfpRfqFloatingDate).format("DD MMM YYYY") : '-'}
                //         </>
                //     ),
                // },
                // {
                //     name: "Cutoff Date For Receipt Of Bids",
                //     field: "bidReceiptCutoffDate",
                //     renderer: (row) => (
                //         <>
                //             {row?.bidReceiptCutoffDate ? moment(row.bidReceiptCutoffDate).format("DD MMM YYYY") : '-'}
                //         </>
                //     ),
                // },
                {
                    name: "Planned Date Of Release Of LOI/WO/PO",
                    field: "plannedLoiReleaseDate",
                    renderer: (row) => (
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {row?.plannedLoiReleaseDate ? moment(row.plannedLoiReleaseDate).format("DD MMM YYYY") : '-'}
                        </Box>
                    ),
                },
                {
                    name: "Planned Date Of Tender Package",
                    field: "plannedDateOfTenderPackage",
                    renderer: (row) => (
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {row?.plannedDateOfTenderPackage ? moment(row.plannedDateOfTenderPackage).format("DD MMM YYYY") : '-'}
                        </Box>
                    ),
                },

                {
                    name: "Planned Finish Of The Activity At Site",
                    field: "plannedFinishAtSiteDate",
                    renderer: (row) => (
                        <>
                            {row?.plannedFinishAtSiteDate ? moment(row.plannedFinishAtSiteDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Lead Time (Days)",
                    field: "leadTimeDays",
                    renderer: (row) => (
                        <>
                            {row?.leadTimeDays ? row?.leadTimeDays : '-'}
                        </>
                    ),
                },
                {
                    name: "Mobilization Required Days Left",
                    field: "mobilizationRequiredDaysLef",
                    renderer: (row) => (
                        <>
                            {row?.mobilizationRequiredDaysLeft ? row?.mobilizationRequiredDaysLeft : '-'}
                        </>
                    ),
                },
                {
                    name: "Last Updated Date",
                    field: "lastUpdatedDate",
                    renderer: (row) => (
                        <>
                            {row?.lastUpdatedDate ? moment(row.lastUpdatedDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Status",
                    field: "status",
                    renderer: (row) => (
                        <>
                            {row?.status ? row?.status : '-'}
                        </>
                    ),
                },
                {
                    name: "Remarks / Notes",
                    field: "remark",
                    width: "300px",
                    renderer: (row) => (
                        <>
                            {row?.remark ? row?.remark : '-'}
                        </>
                    ),
                },
            ];
        }
    };

    // React.useEffect(() => {
    //     if (addActionTrackerRes?.isSuccess) {
    //         if (!addActionTrackerRes?.data?.status) {
    //             openNotification(addActionTrackerRes?.data?.message, 'success')
    //             handleClose();
    //         } else {
    //             openNotification(addActionTrackerRes?.data?.message, 'error')
    //         }
    //     }
    // }, [addActionTrackerRes?.isSuccess]);


    // React.useEffect(() => {
    //     if (addActionTrackerRes?.isError) {
    //         if (addActionTrackerRes?.error?.data?.status == 'fail') {
    //             openNotification(addActionTrackerRes?.error?.data?.message, 'error')
    //         } else {
    //             openNotification('Something went wrong!', 'error')
    //         }
    //         // cancel();
    //     }
    // }, [addActionTrackerRes?.isError]);

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >

            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    {header}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogActions>
                <Box
                    sx={{
                        width: "100%",
                        //borderBottom: "2px solid #ECECEC",
                        overflowX: "auto",
                        whiteSpace: "nowrap",
                        mt: 1,
                        ml: 2,
                    }}
                >
                    <Tabs
                        value={subTabValue}
                        onChange={handleSubTabChange}
                        TabIndicatorProps={{ style: { display: "none" } }}
                        variant="scrollable"
                        scrollButtons={false}
                        sx={{
                            "& .MuiTabs-flexContainer": {
                                gap: "30px",
                            },
                        }}
                    >
                        {subTabs.map((item, index) => (
                            <Tab
                                key={index}
                                label={
                                    <Typography
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            lineHeight: "100%",
                                            color: subTabValue === index ? "#0E73F6" : "#7E7E7E",
                                            fontFamily: "Outfit, sans-serif",
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                }
                                sx={{
                                    textTransform: "none",
                                    minWidth: "auto",
                                    paddingBottom: "5px",
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    borderBottom:
                                        subTabValue === index
                                            ? "2px solid #0E73F6"
                                            : "2px solid transparent",
                                }}
                            />
                        ))}
                    </Tabs>
                </Box>
            </DialogActions>
            <DialogContent dividers>
                <Grid container>
                    <Grid size={{ md: 12 }}>
                        <TableComponent
                            columns={getColumns(subTabValue)}
                            data={getData(subTabValue)}
                            createSortHandler={handleRequestSort}
                            loading={isLoading}
                            order={sortOrder}
                            orderBy={sortBy}
                        />
                    </Grid>
                    <Grid size={{ md: 12 }}>
                        <CustomPagination
                            totalCount={getCount(subTabValue)}
                            pageSize={pageSize}
                            page={pageNumber}
                            onPageChange={handlePageChange}
                            setCurrentPage={setPageNumber}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ProcurementServiceListPopUp;
